function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Account from 'modules/Account';
import CloudDrive from 'modules/CloudDrive';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
const AuthorizeClinicCloudDrive = ()=>{
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const { clinic } = activeClinicMembership;
    const isInProgress = useSelector(selectors.isReauthorizeClinicCloudDriveInProgress);
    const authorizeCloudDrive = useAction(CloudDrive.actions.authorize, clinic.storageProvider, `clinicReAuth-${clinic.organizationUID}-${clinic.name}`);
    return /*#__PURE__*/ _jsx(Button, {
        styleModifier: "primary",
        className: "btn--filled mr-6 mt-6",
        labelMessage: messages.buttons.reauthorizeCloudDrive,
        onClick: authorizeCloudDrive,
        isInProgress: isInProgress
    });
};
const ClinicCloudDrive = ()=>{
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const isAdmin = get(activeClinicMembership, 'isAdmin', false);
    const storageProvider = get(activeClinicMembership, 'clinic.storageProvider');
    if (!isAdmin || !storageProvider) {
        return null;
    }
    const storage = /*#__PURE__*/ _jsx("b", {
        children: get(App.constants.CLOUD_DRIVES_LABELS, storageProvider, storageProvider)
    });
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "section__header",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.cloudDrive))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text--large",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.dataStored), {
                    values: {
                        storage
                    }
                }))
            }),
            /*#__PURE__*/ _jsx(AuthorizeClinicCloudDrive, {})
        ]
    });
};
export default ClinicCloudDrive;
